import React, { InputHTMLAttributes, FC } from 'react'
import classNames from 'classnames'
import { TestTypes } from 'types/models/test.model'

import { IRadioGroupItem } from './types'

import cl from './style.module.scss'

export interface RadioGroupItemProps
	extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> {
	item: IRadioGroupItem
	value: IRadioGroupItem['value']
	onChange: (value: IRadioGroupItem['value']) => void
	disabled?: boolean
	testType?: TestTypes
	viewMode?: boolean
	isFinalTestOngoing?: boolean
}

const RadioGroupItem: FC<RadioGroupItemProps> = ({
	item,
	value,
	onChange,
	disabled,
	name,
	testType,
	viewMode,
	isFinalTestOngoing,
	...defaultProps
}) => (
	<div className={cl.container}>
		<input
			{...defaultProps}
			onChange={onChange.bind(null, item.value)}
			id={item.id}
			type="radio"
			value={item.value}
			name={name}
			checked={+item.value === +value}
			disabled={disabled}
		/>
		<label htmlFor={item.id}>{item.labelTitle}</label>
		{item.isRight &&
			viewMode &&
			+item.value === +value &&
			!isFinalTestOngoing && (
				<label className={classNames(cl.comment, cl.success)}>
					{item.comment}
				</label>
			)}
		{!item.isRight &&
			viewMode &&
			+item.value === +value &&
			!isFinalTestOngoing && (
				<label className={classNames(cl.comment, cl.fail)}>
					{item.comment}
				</label>
			)}
	</div>
)
export default RadioGroupItem
